<template>
    <UiContentwrapper class="flex flex-col mt-0 md:mt-16 mb-16 md:mb-0 md:pb-32">
        <UiFullcolumn>
            <div class="grid grid-cols-1 md:grid-cols-3 pt-5 gap-8">
                <UiPageCard v-motion-slide-visible-once-bottom  v-for="(page, index) in featuredPageData" :key="index" :page="page" />
            </div>
        </UiFullcolumn>
    </UiContentwrapper>
</template>

<script setup>

import { useProductStore } from "@/stores/productStore";
import { usePageStore } from "@/stores/pageStore";

const UiPageCard = defineAsyncComponent(() => import('@/components/ui/PageCard.vue'));


const props = defineProps({
    // Vi får in ett pageobjekt som innehåller både featuredPages och featuredCollections
    page: {
        type: Object,
        required: true,
    },
});


const productStore = useProductStore();
const pageStore = usePageStore();

const { data: featuredPageData, error } = await useAsyncData(
  `featuredPageData-${props.page.id || props.page.handle}`, 
  async () => {
    let featuredPageIds = [];
    let featuredCollectionIds = [];

    if (props.page.featuredPages && props.page.featuredPages.value) {
      try {
        featuredPageIds = JSON.parse(props.page.featuredPages.value);
      } catch (err) {
        console.error("Error parsing featuredPages JSON:", err);
      }
    }

    if (props.page.featuredCollections && props.page.featuredCollections.value) {
      try {
        featuredCollectionIds = JSON.parse(props.page.featuredCollections.value);
      } catch (err) {
        console.error("Error parsing featuredCollections JSON:", err);
      }
    }

    const allIds = [...featuredCollectionIds, ...featuredPageIds];

    const items = await Promise.all(
      allIds.map(async (id) => {
        try {
          let fetchedItem = null;
          if (id.includes("OnlineStorePage")) {
            const pageId = id.replace("OnlineStorePage", "Page");
            fetchedItem = await pageStore.fetchPageByID(pageId);
            return fetchedItem;
          } else if (id.includes("Collection")) {
            fetchedItem = await productStore.fetchCollectionById(id);
            return fetchedItem;
          } else {
            console.warn("Unknown type for id:", id);
          }
          if (!fetchedItem) {
            console.warn("No item returned for id:", id);
          }
        } catch (err) {
          console.error("Error fetching item for id:", id, err);
          return null;
        }
      })
    );

    return items;
  }
);


if (error.value) {
    console.error("Error in useAsyncData:", error.value);
}
</script>